import { createVanIconComponent } from "./van"

const CommentCircle = createVanIconComponent("comment-circle")
export default CommentCircle
